<template>
  <div class="card" data-testid="choose-teams-overlay">
    <div class="w-full p-8">
      <img class="block w-40 mx-auto" src="@/assets/omind_logo.png" alt="txt">
      <h1 class="mb-8 text-center" data-testid="choose-teams-title">
        {{ $t('TeamSelectionOverlayComponent.chooseYourTeam') }}</h1>
      <vee-form @submit="select">
        <div class="relative w-full flex box-border">
          <Listbox v-model="selectedTeam" :options="teams"
              checkmark multiple optionLabel="name" class="w-full mx-4" />
        </div>
        <div class="flex justify-center">
          <button type="submit" :disabled="buttonDisabled" name="regist" id="btn_regist"
            data-testid="choose-teams-submit"
            class="btn-primary-accent py-2.5 px-5 text-base sm:text-lg block mx-auto mt-12">
            {{ $t('TeamSelectionOverlayComponent.select') }}
          </button>
        </div>
      </vee-form>
    </div>
  </div>
</template>
<script>
import { Listbox } from 'primevue';

export default {
  name: 'TeamSelectionOverlayComponent',
  components: { Listbox },
  props: {
    overlay: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      buttonDisabled: false,
      selectedTeam: null,
    };
  },
  computed: {
    teams() {
      return this.$store.getters.getTeamsForSelection;
    },
    selectedTeams() {
      return this.$store.state.content.selectedTeams;
    },
  },
  methods: {
    toggleSelection(team) {
      this.$store.commit('toggleTeamSelection', team._id);
    },
    isChecked(team) {
      return this.$store.state.content.selectedTeams.includes(team._id);
    },
    async select() {
      try {
        this.buttonDisabled = true;
        await this.$store.dispatch('setTeams', {
          id: this.overlay._id,
          teams: this.selectedTeam.map((t) => t._id),
        });
        this.$toast.add({
          severity: 'success',
          summary: this.$t('TeamSelectionOverlayComponent.success'),
          detail: '',
          life: 3000,
        });
        this.$store.dispatch('resetTeams');
        this.buttonDisabled = false;
      } catch (error) {
        this.buttonDisabled = false;
        this.$toast.add({
          severity: 'error',
          summary: error.response.data.message,
          detail: '',
          life: 3000,
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch('getTeams');
  },
  unmounted() {
    this.$store.commit('setSelectedTeams', []);
    this.$store.commit('setTeams', []);
  },
};
</script>
